import { Nullable } from '@/utils/types';
import { isValuePresent } from '@/bundles/App/helpers/isValuePresent';

export const reduceAndSum = (arr: Nullable<string | number>[]) => {
  return arr.reduce((acc: Nullable<number>, currentValue): Nullable<number> => {
    if (isValuePresent(currentValue)) {
      return isValuePresent(acc) ? (acc as number) + parseInt(currentValue as string) : parseInt(currentValue as string);
    }

    return acc;
  }, null);
};
